var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { attrs: { "data-test": "hidden-label" } }, [
    _vm._v("\n  非表示\n  "),
    _c(
      "span",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: {
              content:
                "簡易応募フォームのため、応募者から情報を取得していません。",
            },
            expression:
              "{ content: '簡易応募フォームのため、応募者から情報を取得していません。'}",
          },
        ],
        staticClass: "pega-circle",
        attrs: { "data-test": "hidden-notice-tooltip" },
      },
      [_vm._v("?")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }